module.exports = __webpack_public_path__ + "static/media/treatement.c3a19619.svg";